import { API } from '@Providers';

export default async function fetchAnimalsMedicalCosts() {
  const endpoint = '/api/shelter/cart/fetch-animals-medical-costs';

  return API({ endpoint });
}
